/** biome-ignore-all lint/suspicious/noExplicitAny: suppressed */
import { useTranslations as useNextIntlTranslations } from "next-intl";
import type { MessageKeys } from "@/types/i18n";

export function useSafeTranslations() {
	const tBase = useNextIntlTranslations();

	return (key: MessageKeys, values?: Record<string, any>) => tBase(key, values);
}
